export default __webpack_public_path__ + "static/media/Danny-Black-Background4.6919465f.jpg";